import React, {useState, useEffect} from "react"
import {ReadonlyInput} from "../../Student/Component/Input"
import {Link, useParams} from "react-router-dom"
import Heading from "../../../../Common/Components/Heading"
import axios from "axios"
import url from "../../../../Common/URL"
import { useSelector } from "react-redux"

const HistoryDataComp =()=>{

const { id } = useParams();

    const [state ,setState]= useState({
            uname:sessionStorage.getItem("username"), teacher_id:"",
            // ------------normal input fields--------------
            fname:"",  mname:"", lname:"", city:"", zip:"", mobile_no:"", home_no:"", email:"",
            parent_fname:"", parent_lname:"",   parent_mobile_no:"",  parent_email:"", parent_mobile_no_2:"",
            parent_email_2:"",  join_date:"",  leave_date:"",registration_number:"",approved_date:"",kvk_number:"",
            contract_period:"",contract_renewal_date:"",probation_period:"", 
            // ------------Textarea input fields--------------
            addressline1:"",  addressline2:"",

            // ------------Checkbox input fields--------------
            active:false,   photo_consent:false,  disclaimer_signed:false,

            // ------------Select inputs fields--------------
            state:"",  country:"", location_name:"",  batch_name:"",  level_name:"",  user_name:"",
            picture:null 
    })

    const TeacherDetail = async () =>{
        const obj ={
          uname :state.uname,
          id:id
        }
        axios.post(url+"teacher_history_select", obj)
        .then( (response) => {
            let resData = response.data.data;
            // console.log(resData);
            setState({
                fname:resData[0].fname,  mname:resData[0].mname, lname:resData[0].lname, city:resData[0].city, 
                zip:resData[0].zip, mobile_no:resData[0].mobile_no, home_no:resData[0].home_no,
                email:resData[0].email, parent_fname:resData[0].parent_fname, parent_lname:resData[0].parent_lname,   
                parent_mobile_no:resData[0].parent_mobile_no, parent_mobile_no_2:resData[0].parent_mobile_no_2,
                parent_email:resData[0].parent_email,  join_date:resData[0].join_date,  leave_date:resData[0].leave_date, 
                parent_email_2:resData[0].parent_email_2, registration_number:resData[0].registration_number,
                teacher_id:resData[0].teacher_id, approved_date:resData[0].approved_date,
                probation_period:resData[0].probation_period,contract_renewal_date:resData[0].contract_renewal_date,
                contract_period:resData[0].contract_period, kvk_number:resData[0].kvk_number,
                // ------------Textarea input fields--------------
                addressline1:resData[0].addressline1,  addressline2:resData[0].addressline2,
    
                // ------------Checkbox input fields--------------
                active:resData[0].active,   photo_consent:resData[0].photo_consent,  disclaimer_signed:resData[0].disclaimer_signed,
    
                // ------------Select inputs fields--------------
                state:resData[0].state,  country:resData[0].country, location_name:resData[0].location_name,  batch_name:resData[0].batch_name, 
                level_name:resData[0].level_name,  user_name:resData[0].user_name,
            
            })
        })
        .catch( (err) => console.log(err) );
      }
      
    useEffect(TeacherDetail,[])
    
 return(
   <>
        <div className={useSelector(state => state.sidebar.value) ? 'widthWhenSidebarOpen' : 'widthWhenSidebarClose'}>
{/*----------------------- Bread crumb ------------------------- */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb Breadcrumb align-items-center">
                    <li className="breadcrumb-item"><Link to="/bulletin">Home</Link></li>
                        <li className="breadcrumb-item">Setup</li>
                        <li className="breadcrumb-item" ><Link to="/teacher">Teachers list</Link></li>
                        <li className="breadcrumb-item "><Link to={"/tch-history-table/" + state.teacher_id}>History log</Link></li>
                        <li className="breadcrumb-item active">History details</li>
                    </ol>
                </nav> 
                <Heading name="Details of log" />
{/* ------------------------------------------------- Two Columns for Inputs --------------------------------------- */}
            <form > 
                <div className="container-fluid mt-3">

                    <div className="row mt-5">

                    {/*-----------------------Column-1 for Inputs------------------------- */}
                    <div className="col-11 col-md-6 mx-auto">

                        <h5 className="mb-4">Personal Information</h5>

                            
                            {/* <ReadonlyInput field="Profile Picture" type="file" className="form-control-file"  value={state.picture}/> */}

                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Teacher ID</label>
                                <div className="col-sm-7 col-md-7 ">
                                    <input type="text" readOnly className="form-control bg-light border-0 fw-bold" value={state.teacher_id} />
                                </div>
                            </div>
                            
                            <ReadonlyInput field="First Name"  className="form-control bg-light border-0 " value={state.fname}/>

                            <ReadonlyInput field="Middle Name"  className="form-control bg-light border-0 " value={state.mname}/>

                            <ReadonlyInput field="Last Name"  className="form-control bg-light border-0 "  value={state.lname}/>

                            <div className="mb-3 row">
                            <label className="col-sm-5 col-form-label">Address Line 1</label>
                            <div className="col-sm-7 col-md-7 ">
                                <textarea  readOnly className="form-control bg-light border-0 " placeholder="--" value={state.addressline1}  ></textarea>
                            </div>
                        </div>
                        
                        <div className="mb-3 row">
                            <label className="col-sm-5 col-form-label">Address Line 2</label>
                            <div className="col-sm-7 col-md-7 ">
                                <textarea readOnly className="form-control bg-light border-0 " placeholder="--" value={state.addressline2} ></textarea>
                            </div>
                        </div>

                            <ReadonlyInput field="City"  className="form-control bg-light border-0 "   value={state.city}/>

                           {/* ---Select Input---- */}
                            <ReadonlyInput field="Province"  className="form-control bg-light border-0 "  value={state.state}/>
                           
                            {/* ---Select Input---- */}
                            <ReadonlyInput field="Country"  className="form-control bg-light border-0 "  value={state.country}/>

                            <ReadonlyInput field="Zip"  className="form-control bg-light border-0 " name="zip"  value={state.zip}/>

                            <ReadonlyInput field="Mobile Number"  className="form-control bg-light border-0 " name="mobile_no"  value={state.mobile_no}/>

                            <ReadonlyInput field="Home Phone"  className="form-control bg-light border-0 " name="home_no"  value={state.home_no}/>

                            <ReadonlyInput field="Email" type="email" placeholder="--" className="form-control bg-light border-0 " name="email"  value={state.email}/>

                            <ReadonlyInput field="KVK Number"  className="form-control bg-light border-0 " name="kvk_number"  value={state.kvk_number}/>

                           <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Contract Document</label>
                                <div className="col-sm-7 col-md-7 d-flex align-items-center">
                                   <a href="#" download >View Contract Document &nbsp;<i className="fa fa-download"></i></a>
                                </div>
                            </div>

                    </div>

                        {/*-----------------------Column-2 for Inputs------------------------- */}
                        <div className="col-11 col-md-6 mx-auto">

                        <h5 className="mb-4">Batch Information</h5>

                            {/* ---Select Input---- */}
                            <ReadonlyInput field="Location Name"  className="form-control bg-light border-0 "  value={state.location_name}/>

                            {/* ---Select Input---- */}
                            <ReadonlyInput field="Batch Name"  className="form-control bg-light border-0 "  value={state.batch_name}/>

                            {/* ---Select Input---- */}
                            <ReadonlyInput field="Level Name"  className="form-control bg-light border-0 "  value={state.level_name}/>

                        <h5 className="mt-5 mb-4">Account Information</h5>

                            {/* ---Select Input---- */}
                            <ReadonlyInput field="User"  className="form-control bg-light border-0 "  value={state.user_name}/>
                            
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Active Account</label>
                                <div className="col-sm-7 col-md-7 ps-4">
                                    <div className="form-check">
                                        <input readOnly className="form-check-input" type="checkbox" name="active" checked={state.active}  />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Photography Consent Provided?</label>
                                <div className="col-sm-7 col-md-7 ps-4">
                                <div className="form-check">
                                        <input readOnly className="form-check-input" type="checkbox" name="photo_consent" checked={state.photo_consent}  />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Disclaimer Signed?</label>
                                <div className="col-sm-7 col-md-7 ps-4">
                                <div className="form-check">
                                        <input readOnly className="form-check-input" type="checkbox" name="disclaimer_signed" checked={state.disclaimer_signed}  />
                                    </div>
                                </div>
                            </div>

                            <ReadonlyInput name="join_date"  field="Join Date" type="date" placeholder="Add text" className="form-control bg-light border-0 " value={state.join_date}/>

                            <ReadonlyInput name="probation_period"  value={state.probation_period} field="Probation Period" type="number" placeholder="In Months" className="form-control bg-light border-0 " />

                            <ReadonlyInput name="contract_renewal_date"  value={state.contract_renewal_date} field="Contract Renewal Date" type="date" placeholder="Add text" className="form-control bg-light border-0 " />

                            <ReadonlyInput name="contract_period"  value={state.contract_period} field="Contract Period" type="number" placeholder="In Months" className="form-control bg-light border-0 " />

                            <ReadonlyInput name="leave_date"  value={state.leave_date} field="Leave Date" type="date" placeholder="Add text" className="form-control bg-light border-0 " />
                        </div>
                    </div>
                </div>
            </form>
        </div>
   </>
 )
}
export default HistoryDataComp;